import React from 'react'
import styled from '@emotion/styled'
import { PendingCollateralDetail, UserPreference } from 'api'
import { AgGridWrapper } from 'view/components/datagrid'
import { PendingCollateralColumnDefs, pendingCollateralGridOptions } from './PendingCollateralGridModel'
import { Locale, Translation } from 'locale'
import { useDebounce } from 'view/hooks'

interface PendingCollateralPanelProps {
  collateralList: PendingCollateralDetail[]
  userPreference: UserPreference
}

const Container = styled.div`
  height: 100%;
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;

  h4 {
    margin-bottom: 10px;
  }
`

export const PendingCollateralPanel: React.FC<PendingCollateralPanelProps> = props => {
  const collateralList = useDebounce(props.collateralList, 1000)

  return (
    <Container>
      <h4>{Locale.translate(Translation.TC_PENDING_COLLATERALS)}</h4>
      <AgGridWrapper
        className="datagrid-borderless"
        gridOptions={pendingCollateralGridOptions}
        columnDefs={PendingCollateralColumnDefs}
        rowData={collateralList}
        context={{
          userPreference: {
            dateFormat: props.userPreference.dateFormat
          }
        }}
      />
    </Container>
  )
}
